export const searchSelector = state => state.search;
